var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"datepicker no-autoinit",attrs:{"id":_vm.id,"name":_vm.id,"disabled":_vm.disabled,"type":"text"},on:{"change":function($event){return _vm.onChange($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }